export default "__VITE_ASSET__B1nxkpb6__"